// Make use of a ponyfill for ResizeObserver because Safari doesn't support it.
import ResizeObserver from "resize-observer-polyfill";

import { Component } from "../../extends";
import Content from "./content";

export default (ctx) =>
	class Card extends Component(ctx) {
		events() {
			this.resizeObserver = new ResizeObserver(() => this.resize());
			this.resizeObserver.observe(this.el);
			this.trigger.addEventListener("click", () => this.toggle());
		}

		mounted({ toggleCb = () => null }) {
			this.toggleCb = toggleCb;

			this.index = parseInt(this.el.getAttribute("data-index"), 10);
			this.trigger = this.el.querySelector(".c-card__trigger");

			this.content = new Content(
				this.el.querySelector(".c-card__content")
			);
		}

		enable() {
			this.content.open();

			this.el.classList.add("is-open");
		}

		disable() {
			this.content.close();

			this.el.classList.remove("is-open");
		}

		toggle() {
			if (this.toggleCb) {
				this.toggleCb({
					index: this.index,
				});
			}
		}

		resize() {
			if (this.el.classList.contains("is-open")) {
				this.content.handleResize();
			}
		}
	};
